const pillars = [
  { icon: 'ri-shield-check-line', label: 'Sécurisé' },
  { icon: 'ri-speed-line', label: 'Performant' },
  { icon: 'ri-refresh-line', label: 'Évolutif' },
  { icon: 'ri-focus-3-line', label: 'Sur mesure' },
];

export default function ApproachSection() {
  return (
    <section className="py-24 md:py-32 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">Notre approche</p>
        <h2 className="font-heading font-bold text-navy-900 text-3xl md:text-4xl leading-tight mb-8">
          Rigueur et excellence<br />à chaque projet
        </h2>
        <p className="text-gray-600 text-lg leading-relaxed max-w-2xl mx-auto mb-14">
          Chaque projet est réalisé avec <strong className="text-navy-900 font-semibold">rigueur</strong> afin de proposer des solutions <strong className="text-navy-900 font-semibold">efficaces</strong>, <strong className="text-navy-900 font-semibold">sécurisées</strong> et <strong className="text-navy-900 font-semibold">évolutives</strong>. L'objectif est de concevoir des solutions informatiques qui répondent précisément aux besoins de chaque client.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {pillars.map((p) => (
            <div key={p.label} className="bg-white rounded-xl p-6 flex flex-col items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-navy-900/5 rounded-lg">
                <i className={`${p.icon} text-2xl text-navy-900`}></i>
              </div>
              <span className="font-medium text-navy-900 text-sm">{p.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
